import * as i1$2 from '@angular/cdk/layout';
import { LayoutModule } from '@angular/cdk/layout';
import { NgIf, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, Input, HostListener, EventEmitter, Output, NgModule } from '@angular/core';
import * as i1$1 from '@rogers/cdk/common/a11y';
import { A11yModule } from '@rogers/cdk/common/a11y';
import * as i1 from '@rogers/cdk/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i1$3 from '@angular/forms';
import * as i1$4 from '@rogers/cdk/common/services';

/* eslint-disable @angular-eslint/directive-selector */
class BrandClassDirective {
    constructor(_element, cdkCore) {
        this._element = _element;
        this.cdkCore = cdkCore;
        this._brClass = [];
        this.cdkCore.config$.subscribe(() => this.applyClassChanges());
    }
    set brClass(value) {
        this._brClass = value;
        this.applyClassChanges();
    }
    get brClass() {
        return this._brClass;
    }
    get element() {
        return this._element.nativeElement;
    }
    applyClassChanges() {
        if (this.previousBrand !== this.cdkCore.brand && this.brClass?.length > 0) {
            this.previousBrand = this.cdkCore.brand;
            this.brClass.forEach((list) => {
                const classMap = {
                    rogers: (list || [])[0] || '',
                    fido: (list || [])[1] || '',
                    chatr: (list || [])[2] || '',
                    r4b: (list || [])[3] || '',
                };
                Object.keys(classMap)
                    .filter((k) => k !== this.cdkCore.brand)
                    .forEach((cl) => {
                    if (classMap[cl]) {
                        this.element.classList.remove(classMap[cl]);
                    }
                });
                if (classMap[this.cdkCore.brand]) {
                    this.element.classList.add(classMap[this.cdkCore.brand]);
                }
            });
        }
    }
}
BrandClassDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: BrandClassDirective, deps: [{ token: i0.ElementRef }, { token: i1.CDKCoreService }], target: i0.ɵɵFactoryTarget.Directive });
BrandClassDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: BrandClassDirective, selector: "[brClass]", inputs: { brClass: "brClass" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: BrandClassDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[brClass]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.CDKCoreService }]; }, propDecorators: { brClass: [{
                type: Input
            }] } });

class FocusDirective {
    constructor(_element, focusMonitor) {
        this._element = _element;
        this.focusMonitor = focusMonitor;
    }
    get element() {
        return this._element.nativeElement;
    }
    ngOnChanges(changes) {
        if (changes && changes.focus && changes.focus.currentValue) {
            if (this.eventSource === 'keyboard') {
                this.focusMonitor.focusVia(this.element, 'keyboard');
            }
            else {
                this.element.focus();
            }
        }
    }
}
FocusDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FocusDirective, deps: [{ token: i0.ElementRef }, { token: i1$1.FocusMonitor }], target: i0.ɵɵFactoryTarget.Directive });
FocusDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: FocusDirective, selector: "[focus]", inputs: { focus: "focus", eventSource: "eventSource" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FocusDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[focus]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$1.FocusMonitor }]; }, propDecorators: { focus: [{
                type: Input
            }], eventSource: [{
                type: Input
            }] } });

// eslint-disable-next-line @angular-eslint/directive-selector
class MediaMatchDirective extends NgIf {
    constructor(templateRef, viewContainer, breakpointObserver, cdr) {
        super(viewContainer, templateRef);
        this.breakpointObserver = breakpointObserver;
        this.cdr = cdr;
        this.destroy$ = new Subject();
    }
    set ifMediaMatch(query) {
        if (query !== this.query) {
            this.query = query;
            this.destroy$.next(void 0);
            this.observeBreakpoints();
        }
    }
    set ifMediaMatchThen(templateRef) {
        this.ngIfThen = templateRef;
    }
    set ifMediaMatchElse(templateRef) {
        this.ngIfElse = templateRef;
    }
    observeBreakpoints() {
        this.breakpointObserver
            .observe(this.query)
            .pipe(takeUntil(this.destroy$))
            .subscribe((state) => {
            this.ngIf = state.matches;
            this.cdr.detectChanges();
        });
    }
    ngOnDestroy() {
        this.destroy$.next(void 0);
        this.destroy$.complete();
    }
}
MediaMatchDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: MediaMatchDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: i1$2.BreakpointObserver }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive });
MediaMatchDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: MediaMatchDirective, selector: "[ifMediaMatch]", inputs: { ifMediaMatch: "ifMediaMatch", ifMediaMatchThen: "ifMediaMatchThen", ifMediaMatchElse: "ifMediaMatchElse" }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: MediaMatchDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[ifMediaMatch]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: i1$2.BreakpointObserver }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { ifMediaMatch: [{
                type: Input
            }], ifMediaMatchThen: [{
                type: Input
            }], ifMediaMatchElse: [{
                type: Input
            }] } });

class NgLetDirective {
    constructor(viewContainer, templateRef) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
        this.context = { ngLet: null, $implicit: null };
        this.hasView = false;
    }
    set ngLet(value) {
        this.context.$implicit = this.context.ngLet = value;
        if (!this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef, this.context);
            this.hasView = true;
        }
    }
    /**
     * Asserts the correct type of the context for the template that `NgLet` will render.
     *
     * The presence of this method is a signal to the Ivy template type-check compiler that the
     * `NgLet` structural directive renders its template with a specific context type.
     */
    static ngTemplateContextGuard(dir, ctx) {
        return true;
    }
}
NgLetDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NgLetDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
NgLetDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: NgLetDirective, selector: "[ngLet]", inputs: { ngLet: "ngLet" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NgLetDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngLet]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }]; }, propDecorators: { ngLet: [{
                type: Input
            }] } });

/* eslint-disable @angular-eslint/directive-selector */
class NumbersOnlyDirective {
    constructor(ngControl) {
        this.ngControl = ngControl;
    }
    // Listen for the input event to also handle copy and paste.
    onInput(value) {
        // Use NgControl patchValue to prevent the issue on validation
        this.ngControl.control.patchValue(value.replace(/[^0-9]/g, ''));
    }
}
NumbersOnlyDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NumbersOnlyDirective, deps: [{ token: i1$3.NgControl }], target: i0.ɵɵFactoryTarget.Directive });
NumbersOnlyDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: NumbersOnlyDirective, selector: "input[numbersOnly]", host: { listeners: { "input": "onInput($event.target.value)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NumbersOnlyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[numbersOnly]',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.NgControl }]; }, propDecorators: { onInput: [{
                type: HostListener,
                args: ['input', ['$event.target.value']]
            }] } });

/* eslint-disable @angular-eslint/directive-selector */
class PcaAddressCompleteDirective {
    constructor(el, addressCompleteService) {
        this.el = el;
        this.addressCompleteService = addressCompleteService;
        this.destroyed$ = new Subject();
        this.callback = new EventEmitter();
        this.callbackNotFound = new EventEmitter();
        this.callbackError = new EventEmitter();
    }
    ngOnInit() {
        this.addressCompleteService
            .load(this.pcaConfig.pcaFiles)
            .pipe(takeUntil(this.destroyed$))
            .subscribe((isPcaApiReady) => {
            if (isPcaApiReady) {
                const fields = [
                    {
                        element: this.el.nativeElement,
                        field: 'Label',
                    },
                ];
                try {
                    const control = new window['pca'].Address(fields, {
                        key: this.pcaConfig.pcaKey,
                        culture: this.pcaConfig.culture || 'en-ca',
                        advancedFields: [
                            '{StreetNumber}',
                            '{StreetName}',
                            '{StreetType}',
                            '{StreetDirection}',
                            '{StreetNumberSuffix}',
                            '{StreetPreDirection}',
                            '{StreetPostDirection}',
                        ],
                        bar: {
                            visible: false,
                            showCountry: false,
                            showLogo: false,
                        },
                        search: {
                            maxResults: 300,
                            maxSuggestions: 50,
                            minItems: 1,
                            maxItems: 10,
                        },
                    });
                    control.listen('populate', (address) => {
                        this.callback.emit(address);
                    });
                    control.listen('noresults', () => {
                        this.callbackNotFound.emit();
                    });
                }
                catch (e) {
                    this.callbackError.emit(e);
                }
            }
        });
    }
    ngOnDestroy() {
        this.destroyed$.next(void 0);
        this.destroyed$.complete();
    }
}
PcaAddressCompleteDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PcaAddressCompleteDirective, deps: [{ token: i0.ElementRef }, { token: i1$4.PcaAddressAutoCompleteService }], target: i0.ɵɵFactoryTarget.Directive });
PcaAddressCompleteDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: PcaAddressCompleteDirective, selector: "[pcaAddressComplete]", inputs: { pcaConfig: "pcaConfig" }, outputs: { callback: "callback", callbackNotFound: "callbackNotFound", callbackError: "callbackError" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PcaAddressCompleteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pcaAddressComplete]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$4.PcaAddressAutoCompleteService }]; }, propDecorators: { pcaConfig: [{
                type: Input
            }], callback: [{
                type: Output
            }], callbackNotFound: [{
                type: Output
            }], callbackError: [{
                type: Output
            }] } });

class DirectivesModule {
}
DirectivesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DirectivesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DirectivesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DirectivesModule, declarations: [FocusDirective,
        NumbersOnlyDirective,
        PcaAddressCompleteDirective,
        MediaMatchDirective,
        BrandClassDirective,
        NgLetDirective], imports: [CommonModule, A11yModule, LayoutModule], exports: [FocusDirective,
        NumbersOnlyDirective,
        PcaAddressCompleteDirective,
        MediaMatchDirective,
        BrandClassDirective,
        NgLetDirective] });
DirectivesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DirectivesModule, imports: [[CommonModule, A11yModule, LayoutModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DirectivesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FocusDirective,
                        NumbersOnlyDirective,
                        PcaAddressCompleteDirective,
                        MediaMatchDirective,
                        BrandClassDirective,
                        NgLetDirective,
                    ],
                    imports: [CommonModule, A11yModule, LayoutModule],
                    exports: [
                        FocusDirective,
                        NumbersOnlyDirective,
                        PcaAddressCompleteDirective,
                        MediaMatchDirective,
                        BrandClassDirective,
                        NgLetDirective,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BrandClassDirective, DirectivesModule, FocusDirective, MediaMatchDirective, NgLetDirective, NumbersOnlyDirective, PcaAddressCompleteDirective };
